import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20modern%20Chinese%20online%20community%20forum%20atmosphere%20with%20abstract%20geometric%20patterns%2C%20warm%20orange%20and%20amber%20tones%20blending%20with%20teal%20accents%2C%20digital%20connection%20nodes%20and%20flowing%20data%20streams%2C%20clean%20modern%20aesthetic%2C%20soft%20gradient%20background%20with%20subtle%20texture%2C%20professional%20yet%20welcoming%20feel&width=1800&height=900&seq=hero-haijiao-2026&orientation=landscape"
        alt="海角论坛 - 综合性交流社区平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/35 to-foreground-950/60"></div>

      <div className="relative z-10 container-custom text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/15 backdrop-blur-sm rounded-full border border-background-50/20 mb-6">
            <i className="ri-sparkling-2-line text-primary-400 text-sm"></i>
            <span className="text-sm text-background-50/90">已服务超过 128 万注册会员 · 895 万优质帖子</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-5 font-heading leading-tight">
            海角论坛
            <span className="block text-xl md:text-2xl lg:text-3xl font-medium text-background-50/80 mt-2">
              综合性交流社区平台
            </span>
          </h1>
          <p className="text-base md:text-lg text-background-50/70 mb-8 max-w-2xl mx-auto leading-relaxed">
            汇聚技术讨论、生活分享、数码评测、游戏娱乐等丰富板块，为您提供高质量的社区交流体验。
            无论您是技术达人、生活爱好者还是行业新人，都能在这里找到志同道合的朋友。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/tech-discuss"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all shadow-lg whitespace-nowrap"
            >
              浏览热门帖子
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 rounded-full text-base font-medium border border-background-50/25 hover:bg-background-50/20 transition-all whitespace-nowrap"
            >
              了解更多
              <i className="ri-information-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}